define("shared/components/shared/publish/switcher/item/info-text/index", ["exports", "@ember/component", "@ember/template-factory", "@ember/component/template-only"], function (_exports, _component, _templateFactory, _templateOnly) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/component/template-only"eaimeta@70e063a35619d71f

  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    <div class="o--dropBody">
    <span class="u--text--sm u--text--light" data-test-id="info-text">{{@infoText}}</span>
  </div>
  {{#if @showButton}}
    <div class="o--dropFooter">
      <Shared::Ui::Button
        @additional="block"
        @onClick={{@buttonAction}}
        @size="small"
        @text={{@buttonText}}
        @variant="proceed"
        data-test-id="switch-plan"
      />
    </div>
  {{/if}}
  */
  {
    "id": "vxdLCgfA",
    "block": "[[[10,0],[14,0,\"o--dropBody\"],[12],[1,\"\\n  \"],[10,1],[14,0,\"u--text--sm u--text--light\"],[14,\"data-test-id\",\"info-text\"],[12],[1,[30,1]],[13],[1,\"\\n\"],[13],[1,\"\\n\"],[41,[30,2],[[[1,\"  \"],[10,0],[14,0,\"o--dropFooter\"],[12],[1,\"\\n    \"],[8,[39,1],[[24,\"data-test-id\",\"switch-plan\"]],[[\"@additional\",\"@onClick\",\"@size\",\"@text\",\"@variant\"],[\"block\",[30,3],\"small\",[30,4],\"proceed\"]],null],[1,\"\\n  \"],[13],[1,\"\\n\"]],[]],null]],[\"@infoText\",\"@showButton\",\"@buttonAction\",\"@buttonText\"],false,[\"if\",\"shared/ui/button\"]]",
    "moduleName": "shared/components/shared/publish/switcher/item/info-text/index.hbs",
    "isStrictMode": false
  });

  var _default = (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, (0, _templateOnly.default)());

  _exports.default = _default;
});